module.exports = __webpack_public_path__ + "img/icon5.ed4e5731.gif";